import { HTTPVerbs as o } from "@nextgen-web-framework/core";
import { VersionId as s, ShopId as e } from "./myshopApiConstants.js";
const p = {
  url: `/commyshopas/${s}/myshops`,
  method: o.GET,
  retries: 0
}, t = {
  url: `/commyshopas/${s}/myshops`,
  method: o.POST,
  retries: 0
}, h = {
  url: `/commyshopas/${s}/myshops/${e}`,
  method: o.PUT,
  retries: 0
}, a = {
  url: `/commyshopas/${s}/myshopimages`,
  method: o.POST,
  retries: 0
};
export {
  t as createShopReqObj,
  p as getMyShopReqObj,
  h as updateShopReqObj,
  a as uploadShopImageReqObj
};
//# sourceMappingURL=myshopApiEndPoints.js.map
